import React from 'react'
import "../../styles/SearchMap.css";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductDetails, saveUserEmail } from '../../Services/Events.services';
import { insertCoordinates, insertStores } from '../../store/features/Data';
import swal from 'sweetalert';
import SimpleMap from '../../components/GoogleMaps';
import CircularProgress from '@mui/material/CircularProgress';
import KH_Image from "../../Images/kh_image-1.png";
import kleenhub_logo from "../../Images/plain_logo.png";
import Ellipse from "../../Images/Ellipse.png";
import { Button, IconButton, Box, Modal, TextField } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useParams } from "react-router-dom";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { localStorageEnums } from "../../constants/LocalStorageEnums";
import { LoadingComponent } from '../../components/LoadingComponent';

export const SearchMap = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    // const { product, storeData } = useSelector((state) => state.dataManager.stores);
    const coordinatesRedux = useSelector((state) => state.dataManager.coordinates);
    const [spinnerCoord, setSpinnerCoord] = React.useState(true);
    const [coordinates, setCoordinates] = React.useState({
        lat: '55.6785182',
        lng: '12.563074',
        denied: null
    });
    const [spinnerList, setSpinnerList] = React.useState(false);
    const [storesList, setStoresLists] = React.useState([]);
    const [productData, setProductData] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [email, setEmail] = React.useState(null);
    const [isValidEmail, setIsValidEmail] = React.useState(true);
    const [partnerProductCategoryData, setPartnerProductCategoryData] = React.useState(null);
    const { id: productId } = useParams();

    React.useEffect(() => {
        window.navigator.geolocation.getCurrentPosition(async ({ coords }) => {
          const { latitude, longitude } = coords;
          dispatch(insertCoordinates({ lat: latitude, lng: longitude }));
          window.localStorage.setItem("lat", latitude);
          window.localStorage.setItem("lng", longitude);
          window.localStorage.setItem(localStorageEnums.LOCATIONSTATUS, "granted");
        });
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        document.title = 'kleen hub - Status';  
    }, []);
    
    React.useEffect(() => {
        window.navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
          if (status.state === "granted") {
            window.localStorage.setItem(localStorageEnums.LOCATIONSTATUS, "granted");
          }
          else {
            window.localStorage.setItem(localStorageEnums.LOCATIONSTATUS, "denied");
          }
        })
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        dispatch(insertCoordinates({ lat: window.localStorage.getItem("lat"), lng: window.localStorage.getItem("lng") }));
        // eslint-disable-next-line
    }, [window.localStorage.getItem(localStorageEnums.LOCATIONSTATUS)]);

    React.useEffect(() => {
        const fetchCoordinates = () => {
            window.navigator.geolocation.getCurrentPosition(async ({ coords }) => {
                setSpinnerCoord(true);
                const { latitude, longitude } = coords;
                setCoordinates({
                    lat: latitude,
                    lng: longitude,
                    denied: false
                });
                setSpinnerCoord(false);
                dispatch(insertCoordinates({ lat: latitude, lng: longitude }));
            }, (err) => {
                setCoordinates({
                    lat: 55.6785182,
                    lng: 12.563074,
                    denied: true
                });
                setSpinnerCoord(false);
            });
        }
        if (!coordinatesRedux.lat) {
            fetchCoordinates();
        }
        else {
            setCoordinates(coordinatesRedux);
            setSpinnerCoord(false);
        }
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        const fetchList = async () => {
            try {
                setSpinnerList(true);
                const productResponse = await fetchProductDetails(productId, coordinates);
                if (productResponse.status === 200) {
                    const data = await productResponse?.data;
                    const { productData, storeData, partnerProductCategoryData } = data;
                    if (data) {
                        let storesArr = storeData || [];
                        setStoresLists(storesArr);
                        setProductData(productData);
                        setPartnerProductCategoryData(partnerProductCategoryData);
                        dispatch(insertStores({ product: data.productData, storeData }));
                    }
                }
                setSpinnerList(false);
            } catch (err) {
                setSpinnerList(false)
                swal('Error', err.response.data.message, 'error');
            }
        };
        if(coordinates.denied !== null) {
            fetchList();
        }
        // eslint-disable-next-line
    }, [coordinates]);


    // React.useEffect(() => {
    //     setSpinnerList(true);
    //     setStoresLists(storesList);
    //     setProductData(productData);
    //     setSpinnerList(false);
    // }, [storesList, productData]);


    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const scrollTo = () => {
        const section = document.querySelector( '#second-page' );
        section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    };
    const scrollBack = () => {
        const section = document.querySelector( '#first-page' );
        section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    };
    const daysRemaining = (date) => {
        const diffDays = moment(date).diff(moment(), 'days');
        const diffHours = moment(date).diff(moment(), 'hours');
        const diffMinutes = moment(date).diff(moment(), 'minutes');
        if(diffDays === 0) {
            if(diffHours === 0) {
                return `${diffMinutes} minutes `;
            } else {
                return `${diffHours} hours ${((diffMinutes/60-diffHours)*60).toFixed(0)} minutes `;
            }
        } else {
            return `${diffDays+1} days `;
        }
    }
    const daysDifference = (date1, date2) => {
        return moment(date1).diff(moment(date2), 'days');
    }

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        borderRadius: '10px',
        boxShadow: 24,
        p: 4,
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };

    const handleTextChange = (e) => {
        setEmail(e.target.value);
        setIsValidEmail(true);
    };

    const saveUserEmailNotification = async () => {
        if (validateEmail(email)) {
            try {
                setSpinnerList(true);

                await saveUserEmail({email, consumerId: productData.consumerId});
                setOpen(false);
                setEmail('');
                setSpinnerList(false);
            } catch (err) {
                setSpinnerList(false)
                swal('Error', err.response.data.message, 'error');
            }
        } else {
            setIsValidEmail(false);
        }
    };

    const redirectToLogin = () => {
        history("/login");
    }

    const allStoresName = () => {
        const data = storesList?.length > 0 ? storesList?.map((item) => item.name) : 'any partner on the map';
        return data;
    }

    const getLoginStatus = () => {
        const token = window.localStorage.getItem(localStorageEnums.TOKEN);
        if(token)
            return "none";
        else
            return "black";
    }

    const borrowedCup = () => {
        return (
            <div className='searchmap_background_img container'>
                <a className='title' target={'_blank'} rel={'noreferrer'} href={partnerProductCategoryData?.companyWebsiteUrl || "http://kleenhub.com"}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }}
                        src={partnerProductCategoryData?.companyLogo || kleenhub_logo}/>
                </a>
                <div className="img1" id="first-page">
                    <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={partnerProductCategoryData?.productCategoryImage || KH_Image}/>
                    <div>
                        <div id="oval_parent" className="multi-ellipse">
                            <div id="oval"></div>
                        </div>
                        <p className='text-content-left'>
                            {daysRemaining(productData?.expiryDate)}
                            left to return me.
                        </p>
                        <div className="vertical-center-remind" style={{ display: getLoginStatus(), zIndex: "999", transform: "translate(-40%,0%)" }}>
                            <Button variant="outlined"
                                style={{ backgroundColor: 'transparent', borderRadius: "50%", width: "160px", height: "68px",
                                fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px", display: "block",
                                textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                disableRipple={true}
                                onClick={handleOpen}
                                >
                                    remind me
                            </Button>
                            {/* <Button variant="outlined"
                                style={{ backgroundColor: 'transparent', borderRadius: "50%", width: "160px", height: "68px",
                                fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px", display: "block",
                                textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                disableRipple={true}
                                onClick={redirectToLogin}
                                >
                                    login
                            </Button> */}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                >
                                <Box sx={style}>
                                    <p className='text-content-right' style={{position: 'relative', padding: '0px 30px 0px 30px'}}>
                                        <p style={{fontSize: 'x-large'}}>Enter your email.</p>
                                        You will be reminded 48 hours before expiration
                                    </p>
                                    <TextField margin="normal" color="success"
                                        label="remind me on email" variant="outlined"
                                        inputProps={{ style: { textAlign: "center" } }}
                                        InputLabelProps={{
                                            style: { textAlign: 'center'},
                                        }}
                                        style={{ width: '300px' }}
                                        onChange={(e) => handleTextChange(e)}
                                        error={!isValidEmail}
                                        helperText={!isValidEmail && "Invalid email address"}
                                    />
                                    <Button variant="outlined"
                                        style={{ backgroundColor: 'transparent', borderRadius: '10px', left: '33%', top: '10px', lineHeight: '1', width: "100px", height: "50px",
                                        fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                        textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                        disableRipple={true}
                                        onClick={saveUserEmailNotification}
                                        >
                                            submit
                                    </Button>
                                </Box>
                            </Modal>
                        </div>
                        <div className="vertical-left" >
                            <IconButton aria-label="back" variant="outlined" color="success" onClick={scrollTo}>
                                <ArrowDownwardIcon fontSize='large'/>
                            </IconButton>
                        </div>
                    </div>
                    <div className="Footer">
                        <p>Contact us: care@kleenhub.com</p>
                    </div>
                </div>
                <div className="img2" id="second-page">
                    {(!spinnerList && !spinnerCoord) ?
                        <SimpleMap height={"100%"} mainMarkerTitle={"Your Location"} mainMarkerColor="blue"
                            denied={coordinates.denied} lat={Number(coordinates?.lat || 0)}
                            lng={Number(coordinates?.lng || 0)} stores={storesList || []} /> :
                        <CircularProgress color='warning' />}
                    <div className='div-text'>
                        <div id="oval_parent" className="multi-ellipse">
                            <div id="oval"></div>
                        </div>
                        <p className='text-content-right'>
                            ID: <span className='highlight-text'>{productData?.product}</span><br/>
                            Expiring: <span className='highlight-text'>{moment(productData?.expiryDate).format('DD-MM-YYYY HH:MM:ss')}</span><br/><br/>
                            You can return this {productData?.productCategory} to {allStoresName().toString()}. <br/><br/>
                            If not returned, you will pay {productData?.price?.expiringPrice} {productData?.price?.currency}. and it will become yours.
                        </p>
                        <div className="vertical-left" >
                            <IconButton aria-label="back" variant="outlined" color="success" onClick={scrollBack}>
                                <ArrowUpwardIcon fontSize='large'/>
                            </IconButton>
                        </div>
                    </div>
                </div>
                <div style={{ position: "absolute", top: "550px" }}>
                    <img alt="Ellipse" className="single-ellipse" style={{ position: "relative", top: "-51px", width: "100%" }} src={Ellipse}/>
                </div>
            </div>
        )
    }

    const expiredCup = () => {
        const expiringDate = daysDifference(moment(), productData?.expiryDate);
        if(expiringDate < 30) {
            return expiredExtension()
        } else {
            return expiredNonReturn()
        }
    }

    const expiredExtension = () => {
        return (
            <div className='searchmap_background_img container'>
                <a className='title' target={'_blank'} rel={'noreferrer'} href={partnerProductCategoryData?.companyWebsiteUrl || "http://kleenhub.com"}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }}
                        src={partnerProductCategoryData?.companyLogo || kleenhub_logo}/>
                </a>
                <div className="img1" id="first-page">
                    <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={partnerProductCategoryData?.productCategoryImage || KH_Image}/>
                    <div className='div-text'>
                        <div id="oval_parent" className="multi-ellipse">
                            <div id="oval"></div>
                        </div>
                        <p className='text-content-left'>
                            <span className='warning-blink'>Expired!
                            </span>
                        </p>
                        <div className="vertical-center">
                            <Button variant="outlined"
                                style={{ backgroundColor: 'transparent', borderRadius: "50%", width: "160px", height: "68px",
                                fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                disableRipple={true}
                                onClick={scrollTo}>
                                    continue
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="img2" id="second-page">
                    {(!spinnerList && !spinnerCoord) ?
                        <SimpleMap height={"100%"} mainMarkerTitle={"Your Location"} mainMarkerColor="blue"
                            denied={coordinates.denied} lat={Number(coordinates?.lat || 0)}
                            lng={Number(coordinates?.lng || 0)} stores={storesList || []} /> :
                        <CircularProgress color='warning' />}
                    <div className='div-text'>
                        <div id="oval_parent" className="multi-ellipse">
                            <div id="oval"></div>
                        </div>
                        <p className='text-content-right'>
                            ID: <span className='highlight-text'>{productData?.product}</span><br/>
                            Expired: <span className='highlight-text'>{moment(productData?.expiryDate).format('DD-MM-YYYY HH:MM:ss')}</span><br/><br/>
                            You can still return this {productData?.productCategory} within 7 days to {allStoresName().toString()} and get {productData?.price?.expiringPrice / 2} {productData?.price?.currency} back.<br/><br/>
                            Refunds are automatic.
                        </p>
                        <div className="vertical-left" >
                            <IconButton aria-label="back" variant="outlined" color="success" onClick={scrollBack}>
                                <ArrowUpwardIcon fontSize='large'/>
                            </IconButton>
                        </div>
                    </div>
                </div>
                <div style={{ position: "absolute", top: "550px" }}>
                    <img alt="Ellipse" className="single-ellipse" style={{ position: "relative", top: "-51px", width: "100%" }} src={Ellipse}/>
                </div>
            </div>
        )
    }

    const expiredNonReturn = () => {
        return (
            <div className='searchmap_background_img container'>
                <a className='title' target={'_blank'} rel={'noreferrer'} href={partnerProductCategoryData?.companyWebsiteUrl || "http://kleenhub.com"}>
                    <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }}
                        src={partnerProductCategoryData?.companyLogo || kleenhub_logo}/>
                </a>
                <div className="img1" id="first-page">
                    <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={partnerProductCategoryData?.productCategoryImage || KH_Image}/>
                    <div className='div-text'>
                        <div id="oval_parent" className="multi-ellipse" style={{ display: "block" }}>
                            <div id="oval"></div>
                        </div>
                        <p className='text-title-center'>
                            <span className='warning-blink'>Expired!</span>
                            <p className='text-content-center'>
                            ID: <span className='highlight-text'>{productData?.product}</span><br/>
                            Expired: <span className='highlight-text'>{moment(productData?.expiryDate).format('DD-MM-YYYY HH:MM:ss')}</span><br/><br/>
                            Unfortunately you can't return items expired more than 14 days ago.<br/><br/>
                            This cup is all yours, enjoy!
                        </p>
                        </p>
                    </div>
                </div>
                <div style={{ position: "absolute", top: "550px", maxWidth: 'min-content' }}>
                    <img alt="Ellipse" className="single-ellipse" style={{ position: "relative", top: "-51px", width: "100%" }} src={Ellipse}/>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Helmet>
                <title>kleen status</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {productData ? (
                productData.status === 'Borrowed' ? borrowedCup() :
                productData.status === 'Expired' ? expiredCup() : null
                ) : <LoadingComponent loader={true}></LoadingComponent>
            }
        </div>
    )
}
